<template>
  <div class="awards-top-section__nominate-btn-wrapper">
    <a-visibility :hide="true" :on="[$breakpoint.mobile]">
      <a-nominate-button class="awards-top-section__nominate-btn">
        Nominate now
      </a-nominate-button>
    </a-visibility>

    <a-visibility :show="true" :on="[$breakpoint.mobile]">
      <a-nominate-button
        :border-radius-small="true"
        class="awards-top-section__nominate-btn"
      >
        Nominate now
      </a-nominate-button>
    </a-visibility>
  </div>
</template>

<script>
import ANominateButton from 'sections/_homepage/shared/ANominateButton'

export default {
  name: 'AwardsTopSectionNominateButton',
  components: { ANominateButton }
}
</script>

<style lang="scss" scoped>
.awards-top-section__nominate-btn-wrapper {
  display: flex;

  .awards-top-section__nominate-btn {
    display: flex;
    margin: 64px auto;

    $padding: (
      $above-desktop-xl: 25px 50px,
      $mobile: 13px 50px
    );

    @include setStyleByBreakpoint('padding', $padding);
  }
}
</style>
